import script from "./QrCode.vue?vue&type=script&lang=ts&setup=true"
export * from "./QrCode.vue?vue&type=script&lang=ts&setup=true"

import "./QrCode.vue?vue&type=style&index=0&id=3e27bfba&scoped=true&lang=less"

import exportComponent from "D:\\鹿小岚\\crm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3e27bfba"]])

export default __exports__